const REGEX_INTERPOLATE = /{{([\s\S]+?)}}/g;

export type TemplateRenderer<T extends string> = (params: {
  [K in T]: string;
}) => string;

export function applyTemplateParameters(args: {
  template: string;
  parameters: Record<string, string | null>;
}): string {
  const { template, parameters } = args;
  const templateKeys: string[] = [];
  let match: RegExpExecArray | null;
  while ((match = REGEX_INTERPOLATE.exec(template))) {
    templateKeys.push(match[1]);
  }

  // copy
  let compiled = template.slice();
  for (const key of templateKeys) {
    if (!(key in parameters)) continue;
    const param = parameters[key];
    if (!param) continue;
    compiled = compiled.replace(`{{${key}}}`, param);
  }
  return compiled;
}
